import 'reflect-metadata';

import { injectable } from 'inversify';

import { UnifiedRolesEditorPolicyResolverEnum } from './enums';
import { IUnifiedRolesEditorPolicyConstructor } from './interfaces';
import { UnifiedRolesEditorResolver } from './policies/UnifiedRolesEditorResolver';

@injectable()
export class UnifiedRolesEditorPolicyResolver {
  public resolveUnifiedRolesEditorPolicy(
    unifiedRolesEditorPolicy: UnifiedRolesEditorPolicyResolverEnum,
  ): IUnifiedRolesEditorPolicyConstructor {
    const { DEFAULT_POLICY } = UnifiedRolesEditorPolicyResolverEnum;

    const resourceUnifiedRolesEditorPolicies: {
      [K in UnifiedRolesEditorPolicyResolverEnum]: IUnifiedRolesEditorPolicyConstructor;
    } = {
      [DEFAULT_POLICY]: UnifiedRolesEditorResolver,
    };

    return resourceUnifiedRolesEditorPolicies[unifiedRolesEditorPolicy];
  }
}
